import { render, staticRenderFns } from "./Deviations.vue?vue&type=template&id=afb2891e&lang=pug&"
import script from "./Deviations.vue?vue&type=script&lang=ts&"
export * from "./Deviations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports